import React from "react";

import useConfig from "hooks/useConfig";
import GenericModal from "components/ui/GenericModal";

const links = {
  thameslink: {
    smartcard: "https://www.thameslinkrailway.com/tickets/the-key-smartcard",
    keyGo: "https://www.thameslinkrailway.com/tickets/the-key-smartcard/keygo"
  },
  greatnorthern: {
    smartcard: "https://www.greatnorthernrail.com/tickets/the-key-smartcard",
    keyGo: "https://www.greatnorthernrail.com/tickets/the-key-smartcard/keygo"
  }
};

const SmartCarnetInfoModal = ({ closeModal }) => {
  const { redirectUrl } = useConfig();

  const brandLinks = Object.keys(links).filter(brand => redirectUrl.includes(brand));
  const brandLink = brandLinks.length ? links[brandLinks[0]] : links.thameslink;

  return (
    <GenericModal closeModal={closeModal} title="keyGo Carnet">
      <p>
        The Key Smartcard offers an easier and faster way to buy, renew and use train tickets,
        compared to paper tickets. It’s a great way to minimise social contact. Please{" "}
        <a
          href={brandLink.smartcard}
          className="otrl-jp__text-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          click here
        </a>{" "}
        for further information on the Key Smartcard.
      </p>

      <p>
        keyGo Carnet is a smart version of paper Carnet tickets, keyGo Carnets are held within your
        online account. It works in conjunction with keyGo (our account-based pay as you go product,{" "}
        <a
          href={brandLink.keyGo}
          className="otrl-jp__text-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          find out more
        </a>
        ).
      </p>
    </GenericModal>
  );
};

export default SmartCarnetInfoModal;
